import 'css-chunksrc/client/pages/projectPortfoliosPage/projectPortfolios/styles.scss';export default {
  "projectPortfolios": "_projectPortfolios_18ev2_1"
};